import React, { useEffect } from "react";
import { useSettings } from "../context/SettingsContext";

const PHONE = "+225 01 02 84 94 17";

const ARTICLES = [
  {
    t: "Article 1 — Objet",
    p: [
      "Les présentes Conditions Générales de Vente (CGV) définissent les conditions dans lesquelles Le Dressing de Yoyo propose et commercialise ses produits sur le site www.ledressingdeyoyo.com.",
      "Elles s'appliquent à toute commande effectuée par un consommateur sur le site et précisent les droits et obligations du vendeur et de ses clients.",
      "Le Client reconnaît avoir pris connaissance des présentes CGV avant la validation de sa commande et les accepter sans réserve, sous réserve des dispositions légales impératives.",
    ],
  },
  {
    t: "Article 2 — Identification du vendeur",
    p: [
      "Nom commercial : Le Dressing de Yoyo",
      "Localisation : Abidjan, Côte d'Ivoire",
      "Téléphone / WhatsApp : +225 01 02 84 94 17",
      "Adresse e-mail : contact.ledressingdeyoyo@gmail.com",
      "Site internet : www.ledressingdeyoyo.com",
    ],
  },
  {
    t: "Article 3 — Produits",
    p: [
      "Le Dressing de Yoyo commercialise des vêtements et accessoires de mode, principalement destinés aux femmes.",
      "Les produits peuvent être neufs ou de seconde main.",
      "Chaque fiche produit présente, dans la mesure des informations disponibles, les caractéristiques essentielles de l'article : description, marque, taille, couleur, état, prix et photographies.",
      "Les articles de seconde main peuvent présenter des traces d'utilisation. Les défauts connus sont précisés dans leur description ou présentés sur les photographies.",
      "Le Dressing de Yoyo veille à reproduire fidèlement les couleurs et les caractéristiques des vêtements. De légères variations de rendu peuvent néanmoins résulter des réglages des écrans.",
    ],
  },
  {
    t: "Article 4 — Disponibilité",
    p: [
      "Les articles sont proposés dans la limite des stocks disponibles.",
      "Certains vêtements sont disponibles en exemplaire unique.",
      "En cas d'indisponibilité d'un article après paiement, le Client sera informé dans les meilleurs délais et pourra choisir entre un produit de remplacement, avec son accord, ou le remboursement du produit indisponible.",
    ],
  },
  {
    t: "Article 5 — Prix",
    p: [
      "Tous les prix sont affichés en francs CFA (XOF).",
      "Les prix applicables sont ceux indiqués lors de la validation de la commande, avec les mentions fiscales correspondant au régime du vendeur.",
      "La livraison est gratuite pour toute commande livrée à Abidjan : aucun frais de livraison n'est ajouté au prix affiché des produits.",
      "Le Dressing de Yoyo peut modifier ses prix à tout moment, sans effet rétroactif sur les commandes déjà conclues.",
    ],
  },
  {
    t: "Article 6 — Commande",
    p: [
      "Le Client sélectionne les articles souhaités et les ajoute à son panier.",
      "Avant de confirmer son achat, il peut vérifier et corriger les informations de sa commande, notamment les articles, quantités, prix et coordonnées de livraison.",
      "La validation définitive de la commande entraîne une obligation de paiement.",
      "Une confirmation récapitulative est transmise au Client par voie électronique.",
      "Le Dressing de Yoyo peut demander une vérification complémentaire lorsqu'une commande présente une anomalie ou une suspicion raisonnable de fraude.",
    ],
  },
  {
    t: "Article 7 — Paiement",
    p: [
      "Le paiement des commandes s'effectue exclusivement par Mobile Money, au moyen des solutions effectivement disponibles et indiquées sur le site.",
      "Le paiement est exigible lors de la validation de la commande.",
      "Le paiement à la livraison n'est pas accepté.",
      "La préparation et l'expédition des commandes interviennent après confirmation du paiement.",
      "Le Client est responsable de l'exactitude des informations fournies pour effectuer la transaction.",
      "Le Dressing de Yoyo ne demande jamais aux Clients de communiquer leurs codes secrets ou confidentiels Mobile Money.",
      "En cas de paiement débité sans confirmation de commande, le Client est invité à contacter le service client en fournissant la référence de la transaction, sans communiquer de code confidentiel.",
    ],
  },
  {
    t: "Article 8 — Zone et modalités de livraison",
    p: [
      "Le Dressing de Yoyo assure les livraisons uniquement à Abidjan, dans les zones effectivement desservies par son service de livraison.",
      "Le Client doit fournir une adresse complète et suffisamment précise, notamment sa commune, son quartier, un point de repère et un numéro de téléphone joignable.",
      "La livraison est effectuée à l'adresse communiquée lors de la commande.",
      "Les délais de livraison estimés sont communiqués avant la confirmation définitive de l'achat.",
      "En cas de retard ou de difficulté, le Client peut contacter le service client afin d'obtenir des informations sur sa commande et d'exercer ses droits légaux.",
    ],
  },
  {
    t: "Article 9 — Frais de livraison",
    p: [
      "La livraison est assurée uniquement à Abidjan et elle est gratuite, quelle que soit la commune desservie.",
      "Aucun frais de livraison n'est facturé au Client pour une commande livrée à Abidjan.",
      "Aucun supplément non accepté par le Client ne pourra être imposé après la conclusion de la commande.",
      "Si l'adresse fournie est incorrecte ou incomplète, une nouvelle livraison peut donner lieu à des frais supplémentaires, après information et accord du Client, sous réserve des règles légales applicables.",
    ],
  },
  {
    t: "Article 10 — Réception des articles",
    p: [
      "À la réception de sa commande, le Client est invité à vérifier les articles livrés.",
      "Si un produit est manquant, incorrect, endommagé ou présente un défaut non signalé, le Client peut contacter le service client en indiquant son numéro de commande et, si possible, en fournissant des photographies.",
      "L'absence de réserve au moment de la livraison ne supprime pas les droits légaux du consommateur.",
    ],
  },
  {
    t: "Article 11 — Retours et échanges",
    p: [
      "Conformément à l'article 11 de la loi ivoirienne n° 2016-412 relative à la consommation, le Client bénéficie, pour les ventes à distance, d'un délai légal de dix (10) jours ouvrables à compter de la livraison pour retourner le produit afin d'obtenir un échange ou un remboursement, sans pénalité, à l'exception des frais de retour légalement applicables.",
      "Pour organiser un retour, le Client est invité à contacter le service client par e-mail ou WhatsApp en précisant son numéro de commande et le produit concerné.",
      "Les modalités pratiques et l'adresse de retour lui seront communiquées.",
      "Les articles doivent être retournés avec soin et, dans la mesure du possible, avec leurs accessoires et emballages.",
      "Toute éventuelle dégradation imputable au Client est appréciée conformément aux règles légales applicables.",
      "Le caractère neuf ou de seconde main d'un article ne supprime pas, à lui seul, les droits légaux du Client.",
      "Les échanges sont soumis à la disponibilité des articles. Les pièces uniques ne peuvent pas toujours être remplacées par un modèle identique.",
    ],
  },
  {
    t: "Article 12 — Remboursements",
    p: [
      "Lorsqu'un remboursement est dû, Le Dressing de Yoyo procède au remboursement des sommes concernées conformément aux délais et modalités prévus par la législation applicable.",
      "Le remboursement peut être effectué par Mobile Money sur un numéro communiqué et vérifié avec le Client, ou par tout autre moyen légalement admis et convenu entre les parties.",
      "En cas d'article indisponible après paiement, le Client peut demander le remboursement correspondant.",
      "En cas de produit non conforme, défectueux ou livré par erreur, les droits du Client sont préservés, y compris en matière de frais de retour et de remboursement.",
    ],
  },
  {
    t: "Article 13 — Tailles et état des vêtements",
    p: [
      "Les tailles sont indiquées selon les informations disponibles sur les étiquettes ou les caractéristiques des articles.",
      "Les correspondances peuvent varier d'une marque à l'autre.",
      "Lorsque la taille n'est pas connue, la mention « Taille non renseignée » peut apparaître sur la fiche produit.",
      "Le Client est invité à consulter les mesures éventuellement indiquées et à solliciter le service client en cas de doute.",
      "Les éventuelles particularités des vêtements de seconde main sont précisées dans leur description.",
      "Ces informations ne limitent pas les garanties légales applicables.",
    ],
  },
  {
    t: "Article 14 — Responsabilité et garanties légales",
    p: [
      "Le Dressing de Yoyo s'engage à livrer des produits conformes à leur description et à respecter les obligations prévues par la législation ivoirienne.",
      "Le Vendeur ne peut être exonéré de ses obligations légales de conformité, de garantie ou de livraison par les présentes CGV.",
      "La responsabilité du Vendeur peut être appréciée conformément à la loi en cas de force majeure, de faute du Client ou de tout autre événement légalement reconnu.",
    ],
  },
  {
    t: "Article 15 — Données personnelles",
    p: [
      "Le Dressing de Yoyo collecte et traite les données personnelles nécessaires à la gestion des commandes, au paiement, à la livraison et au service client.",
      "Ces données peuvent notamment comprendre le nom, le numéro de téléphone, l'adresse e-mail, l'adresse de livraison et les informations relatives à la commande.",
      "Le traitement des données s'effectue conformément à la loi ivoirienne n° 2013-450 du 19 juin 2013 relative à la protection des données à caractère personnel.",
      "Les données peuvent être transmises aux prestataires intervenant dans le paiement, la livraison ou l'hébergement du site, dans la mesure nécessaire à leurs missions et conformément à la réglementation.",
      "Le Client dispose des droits prévus par la loi et peut contacter Le Dressing de Yoyo pour les exercer.",
      "Les modalités détaillées de collecte, de conservation et de protection des données figurent dans la Politique de confidentialité du site.",
    ],
  },
  {
    t: "Article 16 — Propriété intellectuelle",
    p: [
      "Les textes, photographies, logos, éléments graphiques et contenus originaux du site sont protégés par les règles de propriété intellectuelle applicables.",
      "Toute reproduction ou exploitation non autorisée est interdite, sauf exceptions légales.",
      "Les marques de vêtements présentées sur le site appartiennent à leurs propriétaires respectifs.",
    ],
  },
  {
    t: "Article 17 — Service client et réclamations",
    p: [
      "Pour toute demande concernant une commande, un paiement, une livraison ou un retour, le Client peut contacter Le Dressing de Yoyo :",
      "E-mail : contact.ledressingdeyoyo@gmail.com",
      "Téléphone / WhatsApp : +225 01 02 84 94 17",
      "Le Client est invité à préciser son numéro de commande afin de faciliter le traitement de sa demande.",
      "Le Dressing de Yoyo s'engage à examiner les réclamations avec diligence et à rechercher une solution amiable conforme aux droits du consommateur.",
    ],
  },
  {
    t: "Article 18 — Modification des CGV",
    p: [
      "Le Dressing de Yoyo peut modifier les présentes CGV pour tenir compte de l'évolution de son activité ou de la réglementation.",
      "Les CGV applicables sont celles acceptées par le Client au moment de la validation de sa commande.",
    ],
  },
  {
    t: "Article 19 — Droit applicable et litiges",
    p: [
      "Les présentes CGV sont soumises au droit ivoirien.",
      "En cas de différend, les parties sont invitées à rechercher une solution amiable.",
      "À défaut, le litige pourra être soumis aux autorités ou juridictions légalement compétentes, sans préjudice des droits impératifs du consommateur.",
    ],
  },
  {
    t: "Article 20 — Acceptation",
    p: [
      "La validation d'une commande implique que le Client reconnaît avoir pu consulter, conserver et accepter les présentes Conditions Générales de Vente.",
    ],
  },
];

export default function CGV() {
  const { settings } = useSettings();
  const phone = settings?.whatsapp_number || PHONE;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:py-20" data-testid="cgv-page">
      <h1 className="font-serif text-4xl text-[#2C1A14] sm:text-5xl">Conditions Générales de Vente</h1>
      <div className="mt-4 space-y-0.5 text-sm text-[#9B7E73]">
        <p className="font-medium text-[#6E544A]">Le Dressing de Yoyo</p>
        <p>Site internet : www.ledressingdeyoyo.com</p>
        <p>Établissement : Abidjan, Côte d'Ivoire</p>
        <p>Dernière mise à jour : 8 octobre 2026</p>
      </div>

      <div className="mt-10 space-y-8">
        {ARTICLES.map((a) => (
          <section key={a.t} data-testid="cgv-article">
            <h2 className="font-serif text-xl text-[#D76E4D]">{a.t}</h2>
            <div className="mt-2 space-y-2">
              {a.p.map((para, i) => (
                <p key={i} className="text-[15px] leading-relaxed text-[#4A3B34]">{para.replace(PHONE, phone)}</p>
              ))}
            </div>
          </section>
        ))}
      </div>

      <div className="mt-12 border-t border-[#E8D5CE] pt-6 text-sm italic text-[#9B7E73]">
        <p className="font-serif text-base not-italic text-[#2C1A14]">LE DRESSING DE YOYO</p>
        <p>Abidjan, Côte d'Ivoire — www.ledressingdeyoyo.com</p>
        <p className="mt-1">Une histoire de mode. Une histoire de famille. Un dressing qui se partage.</p>
      </div>
    </div>
  );
}
